<template>
    <header :class="b()">
        <dtg-grid padding="none">
            <dtg-row>
                <dtg-col :class="b('pane')" size="auto">
                    <dtg-action
                        :class="b('logo')"

                        href="/"
                        routed
                    >
                        <img
                            :class="b('logo-image')"

                            src="/assets/icon/logo-with-text-light.svg"
                            alt="MyDTG Terrain"
                        />
                    </dtg-action>
                </dtg-col>
                <dtg-col :class="b('pane', { second: true })">
                    <nav>
                        <ul :class="b('nav')">
                            <template v-if="user">
                                <li>
                                    <dtg-header-button
                                        :class="b('action')"

                                        :href="listHref"

                                        icon-name="folder"

                                        routed
                                    >
                                        DTG
                                    </dtg-header-button>
                                </li>
                                <li>
                                    <dtg-header-dropdown />
                                </li>
                            </template>
                            <template v-else>
                                <li>
                                    <dtg-header-button
                                        :class="b('action')"

                                        :href="aboutHref"

                                        icon-name="information"

                                        routed
                                    >
                                        A propos de MyDTG
                                    </dtg-header-button>
                                </li>
                                <li>
                                    <dtg-header-button
                                        :class="b('action')"

                                        v-bind="backofficeLinkProps"

                                        icon-name="dashboard"
                                    >
                                        MyDTG Manager
                                    </dtg-header-button>
                                </li>
                                <li>
                                    <dtg-header-button
                                        :class="b('action')"

                                        :href="loginHref"

                                        icon-name="user"

                                        routed
                                    >
                                        Connexion
                                    </dtg-header-button>
                                </li>
                            </template>
                        </ul>
                    </nav>
                </dtg-col>
            </dtg-row>
        </dtg-grid>
    </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import { DtgAction, DtgCol, DtgGrid, DtgRow, getName, useBem } from 'dtg-components';

import { useAuth } from '@/composables/use-auth';
import { useBackofficeLink } from '@/composables/use-backoffice-link';

import { BACKOFFICE_URL } from '@/utils/backoffice-app-routes';

import { Route } from '@/router';

import { DtgHeaderButton } from './elems/header-button';
import { DtgHeaderDropdown } from './elems/header-dropdown';

import styles from './style.module.scss';

export default defineComponent({
    name: getName(styles),

    components: {
        DtgGrid,
        DtgRow,
        DtgCol,
        DtgAction,
        DtgHeaderButton,
        DtgHeaderDropdown,
    },

    setup() {
        const { user } = useAuth();
        const router = useRouter();

        const aboutHref = router.resolve({ name: Route.about });
        const listHref = router.resolve({ name: Route.list });
        const loginHref = router.resolve({ name: Route.authLogin });
        const backofficeLinkProps = useBackofficeLink(BACKOFFICE_URL);

        return {
            b: useBem(styles),

            user,
            aboutHref,
            listHref,
            loginHref,
            backofficeLinkProps,
        };
    },
});
</script>
